import type { ReactElement } from 'react';

export enum FeatureIDs {
    unlim = 'unlim',
    noads = 'noads',
    family = 'family',
    familyAlbums = 'family-albums',
    upload = 'upload',
    others = 'others',
    duplicates = 'duplicates',
}

export interface FeatureItem {
    id: FeatureIDs;
    type: 'normal' | 'disabled' | 'highlighted';
    text: string | ReactElement;
    iconBefore: ReactElement;
    iconAfter?: ReactElement;
}
